import { type ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <Navbar />
      <main className="w-full">{children}</main>
      <Footer />
      <BackToTop />
    </>
  );
}